import React, { Component } from "react";
import { applyDataTable } from '../../custom/dataTable';
import Delete from '../../../assets/img/svg/delete.svg';
import del from "../../../assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../custom/textField"
import Select from "react-select";
import closeIcon from "../../../assets/img/svg/closeIcon.svg";
import { roleTypeString, additionalRoles, additionalRole, yardCommonRoles, yardCommonRole, yardOwnerRole, adminRole, shipOwnerRole } from "../../common/commonJson";
import { characterValidation, dropDownOptions } from "../../common/commonFunction";
import yardIcon from "../../../assets/img/svg/yardRolesIcon.svg";

class YardRoles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            typeId: 0,
            nameError: false,
            searchData: {
                PageNumber: 1,
                PageSize: 100,
            },
            searchCommonData: {
                PageNumber: 1,
                PageSize: 100,
            },
            lookupData: {
                Name: "",
                PageNumber: 1,
                PageSize: 1000000,
            },
            rolesValue: [],
            rolesOptions: [],
            FocusId: 0,
            FocusId1: 0,
            YardId: 0,
            dataListCommon: [],
            rolesDisplay: [],
            HoverIdCommon: 0,
            FocusIdCommon: 0,
            isDisabled: false,
            paging: false,
            existId: [],
            existId1: [],
            isOnChange: false,
            isOnChange1: false,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const userRole = localStorage.getItem("UserRoles");
        this.setState({
            isDisabled: (userRole == shipOwnerRole) ? true : false
        })
        this.setState({
            YardId: localStorage.getItem("YardId") ? localStorage.getItem("YardId") : 0,
            paging: true,
        }, () => {
            this.props.dispatch({ type: "SHOW_LOADER", data: true })
            this.lookupRoleData(this.state.lookupData, roleTypeString);
            this.dataTable(this.state.searchData);
            this.dataTableCommon(this.state.searchCommonData);
        })
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    dataTable = (data) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + additionalRoles + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    response.data?.AdditionalRoles.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataList = response.data;
                    if (!this.state.isDisabled) {
                        this.state.dataList?.AdditionalRoles.push({
                            Id: 0,
                            Name: "",
                            TypeId: 0,
                        })
                    }
                    this.state.render = true;
                    this.setState({})
                    if (this.state.paging == true) {
                        setTimeout(
                            // document.getElementById("additionalTrainings").scrollIntoView(),
                            window.scrollTo(0, 0)
                            , 0)
                        this.setState({
                            paging: false
                        })
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTableCommon = (data) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + yardCommonRoles + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataListCommon = [];
                    this.setState({})
                    response.data?.YardCommonRoles.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataListCommon = response.data;
                    this.state.dataListCommon?.YardCommonRoles.push({
                        Id: 0,
                        Name: "",
                        TypeId: 0,
                    })
                    this.setState({})
                    if (this.state.paging == true) {
                        setTimeout(
                            document.getElementById("topScroll").scrollIntoView(),
                            0)
                        this.setState({
                            paging: false
                        })
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    lookupRoleData = (data, type) => {
        let apiUrl = API.LOOKUP_DATA + '?Name=' + data.Name + '&Type=' + type + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        rolesDisplay: response?.data?.Values
                    })
                    this.setState({
                        rolesOptions: dropDownOptions(response?.data?.Values)?.props?.children
                    })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Yardroles .MuiListItemText-primary").addClass("spanTopBar")
        $("#YRoles .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Roles").addClass("d-none");
        $("#Roles").removeClass("d-block");
        $("#YardRoles").removeClass("active-color");
        $("#YRoles .MuiListItemText-primary").removeClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebaryarddocument");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Yardroles .MuiListItemText-primary").addClass("spanTopBar")
        $("#Roles1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Roles").removeClass("d-none");
        $("#Roles").addClass("d-block");
        $("#YRoles .MuiListItemText-primary").addClass("fw-bolder");
        $("#YardRoles").addClass("active-color");
    };

    post_data = (data) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + additionalRole;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataList?.AdditionalRoles.map((i) => (
                        i.Id == 0 ? (i.Id = response.data, i.Name = this.state.name, i.TypeId = this.state.typeId) : <></>
                    ))
                    this.setState({})
                    this.setState({
                        name: "",
                        typeId: 0,
                    })
                    this.dataTable(this.state.searchData)
                    // this.state.showrow = false;
                    // this.state.actNameFocus = false;
                    this.state.nameError = false;
                    this.state.FocusId = 0;
                    this.state.FocusId1 = 0;
                    // this.state.index = response.data
                    // document.getElementById("actName" + response.data).focus()
                    let id = this.state.dataList?.AdditionalRoles.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList?.AdditionalRoles.push({
                            Id: 0,
                            Name: "",
                            TypeId: 0
                        })
                    }
                    this.state.dataList?.AdditionalRoles.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data, Id) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + additionalRole + '/' + Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData)
                    this.setState({ FocusId1: 0, FocusId: 0, HoverId: 0, HoverId1: 0 })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.deleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + additionalRole + '/' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let data = {
                        Name: "",
                        PageNumber: 1,
                        PageSize: 100,
                    };
                    this.setState({
                        searchData: data,
                    })
                    this.dataTable(data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    handleInputChange1 = (e, str, val, index) => {
        this.setState({
            isOnChange: true,
        })
        if (val == "Name") {
            if (characterValidation(e.target.value) == true) {
                this.state?.dataList?.AdditionalRoles?.map((i) => (
                    i.Id == str.Id ? i.Name = e.target.value : <></>
                ))
            }
        }
        this.setState({})
    }

    handleRoleNameChange = (e) => {
        this.setState({
            isOnChange: true,
        })
        if (characterValidation(e.target.value) == true) {
            this.state.name = e.target.value;
            this.setState({});
        }
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.state.paging = true;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.state.paging = true;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    BackPageCommon = () => {
        this.state.searchCommonData.PageNumber = this.state.searchCommonData.PageNumber - 1;
        this.state.paging = true;
        this.setState({})
        this.dataTableCommon(this.state.searchCommonData)
    }

    NextPageCommon = () => {
        this.state.searchCommonData.PageNumber = this.state.searchCommonData.PageNumber + 1;
        this.state.paging = true;
        this.setState({})
        this.dataTableCommon(this.state.searchCommonData)
    }

    handleInputChange = (e, str, val) => {
        str.Name = e.target.value.trim();
        this.put_data(str, str.Id)
        this.setState({ index: 0 })
        this.state.dataList?.AdditionalRoles.sort((a, b) => {
            return a.Id - b.Id;
        });
        this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
    }

    async postDataBlur(e, str, val) {
        this.setState({
            nameError: true,
        })
        if (this.state.isOnChange == true) {
            this.setState({
                isOnChange: false
            })
            let dataName = e.target.value.trim();
            if (dataName != "" && ((str.Id == 0 && this.state.typeId != 0) || (str.Id != 0))) {
                let url = API.ACTION_YARDROLES + this.state.YardId + API.verifyDuplicate_AdditionalRoles + dataName;
                try {
                    let response = await axios.get(url);
                    if (response?.data == true) {
                        let index = this.state.existId.filter(item => item !== str.Id);
                        this.setState({
                            existId: index
                        })
                        if (str.Id == 0 && this.state.typeId != 0) {
                            let data = {
                                "Name": e.target.value.trim(),
                                "TypeId": this.state.typeId
                            }
                            this.post_data(data)
                        } else if (str.Id != 0) {
                            str.Name = e.target.value.trim();
                            this.put_data(str, str.Id)
                            this.setState({ index: 0 })
                            this.state.dataList?.AdditionalRoles.sort((a, b) => {
                                return a.Id - b.Id;
                            });
                            this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
                        }
                    } else if (response?.data == false) {
                        let data = [...this.state.existId];
                        data.push(str.Id);
                        this.setState({
                            existId: data
                        })
                    }
                } catch (e) {

                }
            }
            else if (dataName == "") {
                if (str.Id != 0) {
                    str.Name = e.target.value.trim();
                    this.put_data(str, str.Id)
                    this.setState({ index: 0 })
                    this.state.dataList?.AdditionalRoles.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
                    this.state.dataList?.YardData?.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                }
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            }
            this.setState({})
        } else {
            this.setState({ index: 0, HoverId: 0 })
        }
    }

    roleChange = (e, val) => {
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let id = parseInt(e.value?.split(',')[0]);
        let data = {
            "Name": val.Name,
            "TypeId": id
        }
        this.state?.dataList?.AdditionalRoles?.map((i) => (
            i.Id == val.Id ? i.TypeId = id : <></>
        ))
        this.put_data(data, val.Id)
    }

    async roleChangePost(e, val) {
        const id = parseInt(e.value?.split(',')[0]);
        this.setState({
            typeId: id,
            nameError: true
        })
        if (this.state.name?.trim() != "" && id != 0) {
            let url = API.ACTION_YARDROLES + this.state.YardId + API.verifyDuplicate_AdditionalRoles + this.state.name?.trim();
            try {
                let response = await axios.get(url);
                if (response?.data == true) {
                    let index = this.state.existId.filter(item => item !== val.Id);
                    this.setState({
                        existId: index
                    })
                    let data = {
                        "Name": this.state.name,
                        "TypeId": id
                    }
                    this.post_data(data)
                } else if (response?.data == false) {
                    let data = [...this.state.existId];
                    data.push(val.Id);
                    this.setState({
                        existId: data
                    })
                }
            } catch (e) {

            }
        }
    }

    handleInputChangeCommon = (e, str) => {
        this.setState({
            isOnChange1: true
        })
        if (characterValidation(e.target.value) == true) {
            this.state?.dataListCommon?.YardCommonRoles?.map((i) => (
                i.Id == str.Id ? i.DisplayName = e.target.value : <></>
            ))
            this.setState({})
        }
    }

    // handleInputChangeCommonBlur = (e, str) => {
    //     let data = {
    //         "DisplayName": str.DisplayName
    //     }
    //     this.put_dataroles(data, str.Id)
    // }

    async handleInputChangeCommonBlur(e, str, val) {
        this.setState({
            nameError: true,
        })
        if (this.state.isOnChange1 == true) {
            this.setState({
                isOnChange1: false
            })
            let dataName = e.target.value.trim();
            if (dataName != "") {
                let url = API.ACTION_YARDROLES + this.state.YardId + API.verifyDuplicate_CommonRoles + dataName;
                try {
                    let response = await axios.get(url);
                    if (response?.data == true) {
                        let index = this.state.existId1.filter(item => item !== str.Id);
                        this.setState({
                            existId1: index
                        })
                        let data = {
                            "DisplayName": str.DisplayName
                        }
                        this.put_dataroles(data, str.Id)
                    } else if (response?.data == false) {
                        let data = [...this.state.existId1];
                        data.push(str.Id);
                        this.setState({
                            existId1: data
                        })
                    }
                } catch (e) {

                }
            }
            else if (dataName == "") {
                let data = {
                    "DisplayName": str.DisplayName
                }
                this.put_dataroles(data, str.Id)
                let index = this.state.existId1.filter(item => item !== str.Id);
                this.setState({
                    existId1: index
                })
            }
        } else {
            this.setState({
                HoverIdCommon: 0,
                FocusIdCommon: 0
            })
        }
        this.setState({})
    }

    put_dataroles = (data, Id) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + yardCommonRole + '/' + Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    // this.dataTable(this.state.searchData)
                    this.setState({ FocusIdCommon: 0 })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };


    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="Yardroles" className='  textNaviIcon' primary="Yard Documents" />
                                            <NavigateNextIcon id="Yardroles1" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    {/* <h4>Additional Roles&nbsp;<img src={yardIcon} /></h4> */}
                                    <h4>Additional Roles</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {/* Additional Roles */}

                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Additional Roles</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-3" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Role</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Type</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList?.AdditionalRoles?.length > 0 ?
                                            <>{this.state?.dataList?.AdditionalRoles && this.state?.dataList?.AdditionalRoles?.map((i, index) => (
                                                i.Id != 0 ?
                                                    <tr className="border-top">
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={this.state.isDisabled ? "border-bg-none" : (this.state.HoverId == i.Id || this.state.index == i.Id || i.Name == "" || this.state.existId?.includes(i.Id) == true) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                    style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id })}
                                                                    onChange={(e) => this.handleInputChange1(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {/* } */}
                                                            {(i.Name == "") ?
                                                                <span className="pt-5" style={{ color: '#DD0000' }}>Role name is required</span> : <></>}
                                                            {(i.Name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                                <span className="pt-5 red-color">Role name is already exist</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            {this.state.isDisabled == true ?
                                                                <span>{this.state.rolesDisplay?.filter((r) => parseInt(r.Id) === i?.TypeId)[0]?.Name}</span> :
                                                                <div
                                                                    onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                                >
                                                                    <Select
                                                                        options={this.state.rolesOptions || []}
                                                                        value={this.state.rolesOptions?.filter((r) => parseInt(r.value?.split(",")[0]) == parseInt(i.TypeId))}
                                                                        placeholder=""
                                                                        classNamePrefix={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "rolesSelect" : "rolesSelectBorderNone"}
                                                                        menuPosition="fixed"
                                                                        menuPlacement="auto"
                                                                        isMulti={false}
                                                                        isSearchable={true}
                                                                        onChange={(e) => this.roleChange(e, i)}
                                                                        onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                        onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                    />
                                                                </div>}
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> : <></>
                                            ))}
                                                {this.state?.dataList?.AdditionalRoles && this.state?.dataList?.AdditionalRoles.map((i) => (
                                                    i.Id == 0 ?
                                                        <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                {/* {(i.Name == "") ? */}
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actName"
                                                                    disabled={this.state.isDisabled}
                                                                    onChange={(e) => this.handleRoleNameChange(e, i, 'Name')}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={this.state.name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-roles spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {((this.state.name.trim() == "" && this.state.typeId != 0 && this.state.nameError == true)) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Role name is required</span> : <></>}
                                                                {(this.state.name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                                    <span className="pt-5 red-color">Role name is already exist</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <Select
                                                                    options={this.state.rolesOptions || []}
                                                                    disabled={this.state.isAccess == false ? true : false}
                                                                    placeholder=""
                                                                    classNamePrefix={"rolesSelect"}
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                    menuPlacement="auto"
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    onChange={(e) => this.roleChangePost(e, i)}
                                                                    onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                    onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                />
                                                                {((this.state.name.trim() != "" && this.state.typeId == 0 && this.state.nameError == true)) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Role type is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                                {/* {(i.Name.trim() != "" || (i.Name.trim() == "" && this.state.nameError == true)) ? <img src={Delete} className="cursorPointer" /> : <></>} */}
                                                            </td>
                                                        </tr> : <></>
                                                ))}</> :
                                            <tr>
                                                <td className="border-top border-left border-right text-center align-middle" colSpan={3}><h6>No data to display</h6></td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.paginationNormal}`} id="topScroll">
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                            {(this.state.searchData.PageNumber == this.state.dataList?.Pagination?.PageCount) || (this.state.dataList?.Pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                        </div>
                    </div>

                    {/* Common Roles */}

                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-12 p-2 mt-3">
                                {/*this.state.isMobile ? <></> : */<h6>Common Roles</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-3" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="33%" style={{ minWidth: '33%', maxWidth: '33%' }}><span className="spandoc-thead">Role</span></th>
                                            <th className="border-top border-right" width="33%" style={{ minWidth: '33%', maxWidth: '33%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Type</span></th>
                                            <th className="border-top border-right" width="34%" style={{ minWidth: '34%', maxWidth: '34%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Display Name</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataListCommon?.YardCommonRoles?.length > 0 ?
                                            <>{this.state?.dataListCommon?.YardCommonRoles && this.state?.dataListCommon?.YardCommonRoles?.map((i, index) => (
                                                i.Id != 0 ?
                                                    <tr className="border-top">
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <span>{i?.Name}</span>
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <span>{this.state.rolesDisplay?.filter((r) => parseInt(r.Id) === i?.TypeId)[0]?.Name}</span>
                                                        </td>
                                                        <td className="align-middle border-right">
                                                            <div className={this.state.isDisabled ? "border-bg-none" : (this.state.HoverIdCommon == i.Id || this.state.FocusIdCommon == i.Id || this.state.existId1?.includes(i.Id) == true) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actNameCommon" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverIdCommon: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverIdCommon: 0 })}
                                                                    style={{ height: $("#actNameCommon" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                    // onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                    onFocus={(e) => this.setState({ FocusIdCommon: i.Id })}
                                                                    onChange={(e) => this.handleInputChangeCommon(e, i)}
                                                                    onBlur={(e) => this.handleInputChangeCommonBlur(e, i)}
                                                                    value={i.DisplayName}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {(i.DisplayName?.trim() != "" && this.state.existId1?.includes(i.Id) == true) ?
                                                                <span className="pt-5 red-color">Display name is already exist</span> : <></>}
                                                        </td>
                                                    </tr> : <></>
                                            ))}</> :
                                            <tr>
                                                <td className="border-top border-left border-right text-center align-middle" colSpan={3}><h6>No data to display</h6></td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.paginationNormal}`}>
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchCommonData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPageCommon()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchCommonData.PageNumber}</span>
                            {(this.state.searchCommonData.PageNumber == this.state.dataListCommon?.Pagination?.PageCount) || (this.state.dataListCommon?.Pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPageCommon()} />}
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(YardRoles))
);
